import { createContext, type Dispatch, type SetStateAction } from 'react'
import type { FormAnonymity } from '../utils/resolveIsAnonymous'

/** What a report form hands over on submit; stored here for the sent page. */
export type SentReport = {
  pin: string | null
  tag: string
  /** `null` when no report was actually sent (the Akutan preview of the sent page). */
  isAnonymous: boolean | null
}

export type OnSent = (report: SentReport) => void

type State = {
  victimPin: string | null
  setVictimPin: (pin: string | null) => void
  createdAt: Date | null
  setCreatedAt: (date: Date) => void
  isSentReportAnonymous: boolean | null
  setIsSentReportAnonymous: (isAnonymous: boolean | null) => void
  tag: string | null
  setTag: (id: string) => void
  formAnonymity: FormAnonymity | null
  setFormAnonymity: Dispatch<SetStateAction<FormAnonymity | null>>
}

export const ReportFormContext = createContext<State>({
  victimPin: null,
  setVictimPin: () => undefined,
  createdAt: null,
  setCreatedAt: () => undefined,
  isSentReportAnonymous: null,
  setIsSentReportAnonymous: () => undefined,
  formAnonymity: null,
  setFormAnonymity: () => undefined,
  tag: null,
  setTag: () => undefined,
})
